"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailHistoryDTO = void 0;
class EmailHistoryDTO {
}
exports.EmailHistoryDTO = EmailHistoryDTO;
//# sourceMappingURL=email-history.dto.js.map